import { createContext } from 'react'

export const KeycloakContext = createContext({
  keycloak: {},
  logout: () => {}
})
